import { JetView } from 'webix-jet';
import { allpayments } from '../../../models/allpayments';
import { devConfig, countries, gamesCasino } from '../../../config/config';

/**
 * Class representing a table view for managing invasive banners.
 * @extends JetView
 */
export default class tableView extends JetView {
    /**
     * Configures the layout of the table view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        return {
            rows: [
                {
                    id: 'preloader',
                    cols: [
                        {
                            view: 'datatable',
                            id: 'datatable',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            select: true,
                            scrollY: true,
                            columns: [
                                {
                                    id: 'rating',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    /**
                                     * Template function to render edit icon based on permissions.
                                     * @param {Object} obj - The data object for the row.
                                     * @returns {String} HTML string for the edit icon or empty string.
                                     */
                                    template: function (obj) {
                                        if (devConfig.getPermAction('bannerInvasiveEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>";
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'GlobalId',
                                    header: 'Global Id',
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Image',
                                    header: _('URL Imagen'),
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Redirection',
                                    header: _('URL Redirección'),
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'Content',
                                    header: _('Contenido'),
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'ButtonText',
                                    header: _('Texto del botón'),
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'ClientId',
                                    header: _('Usuarios Id'),
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'CountrySelect',
                                    header: _('País'),
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'),
                                    css: 'prm-filterByCountry',
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'DateSend',
                                    header: _('Fecha envío'),
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'DateExpiration',
                                    header: _('Fecha expiración'),
                                    width: 300,
                                    sort: 'int',
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'),
                                    editor: 'combo',
                                    options: [
                                        { id: 'A', value: _('Activo') },
                                        { id: 'I', value: _('Inactivo') },
                                    ],
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'State',
                                    header: _('Leido'),
                                    editor: 'combo',
                                    options: [
                                        { id: '1', value: _('Si') },
                                        { id: '0', value: _('No') },
                                    ],
                                    width: 100,
                                    sort: 'int',
                                },
                            ],
                            /**
                             * Event handler for click events on the datatable.
                             * @param {Event} euv - The event object.
                             * @param {String} id - The ID of the clicked row.
                             */
                            onClick: {
                                edit: function (euv, id) {
                                    $$('EditInvasiveBanner').show();
                                },
                            },
                            math: true,
                            loadahead: devConfig.getDefaultDataFetch(),
                            pager: 'pagerA',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers and UI components.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        grid = $$('datatable');
        var url = devConfig.geturlApi() + 'Client/GetClientSendInvasiveBanner';
        var filter = '';
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2) +
            ' ' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getHours()).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getMinutes()).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getSeconds()).slice(-2);
        var popupSendInvasiveBanner = webix.ui({
            view: 'window',
            id: 'SendInvasiveBanner',
            width: screen.width < 500 ? 350 : 650,
            height: screen.width < 500 ? 750 : 550,
            fullscreen: screen.width < 500 ? true : false,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Enviar banner invasivo'),
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center',
            modal: true,
            body: {
                view: 'scrollview',
                scroll: 'y',
                body: {
                    view: 'form',
                    id: 'formSendInvasiveBanner',
                    width: screen.width < 500 ? 350 : 650,
                    height: screen.width < 500 ? 750 : 500,
                    elements: [
                        {
                            view: 'text',
                            label: _('URL Imagen'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Image',
                            labelWidth: 150,
                            required: true,
                        },
                        {
                            view: 'text',
                            label: _('URL Redirección'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Redirection',
                            labelWidth: 150,
                            required: true,
                        },
                        {
                            view: 'textarea',
                            label: _('Contenido'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Content',
                            labelWidth: 150,
                            required: true,
                        },
                        {
                            view: 'text',
                            label: _('Texto del botón'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'ButtonText',
                            labelWidth: 150,
                            required: true,
                        },
                        {
                            view: 'textarea',
                            label: _('Usuarios Id'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'ClientId',
                            labelWidth: 150,
                            required: true,
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelect',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            placeholder: _('Click para seleccionar '),
                            labelWidth: 150,
                            options: {
                                body: {
                                    /**
                                     * Template function for rendering country options with flags.
                                     * @param {Object} obj - The country object.
                                     * @returns {String} HTML string for the country option.
                                     */
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                            required: true,
                        },
                        {
                            view: 'datepicker',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'DateSend',
                            stringResult: true,
                            labelWidth: 150,
                            format: '%d %M %Y %H:%i:%s',
                            value: createdLocalDate,
                            timepicker: true,
                            required: true,
                        },
                        {
                            view: 'datepicker',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'DateExpiration',
                            stringResult: true,
                            labelWidth: 150,
                            format: '%d %M %Y %H:%i:%s',
                            value: createdLocalDate,
                            timepicker: true,
                            required: true,
                        },
                        {
                            cols: [
                                {
                                    view: 'button',
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide();
                                        $$('formSendInvasiveBanner').setValues(
                                            $$('formSendInvasiveBanner').getCleanValues(),
                                        );
                                    },
                                },
                                {
                                    view: 'button',
                                    type: 'form',
                                    value: _('Enviar'),
                                    click: function ($e) {
                                        var values = $$('formSendInvasiveBanner').getValues();
                                        if ($$('formSendInvasiveBanner').validate()) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Client/SendInvasiveBanner',
                                                    '{"Image":"' +
                                                        values.Image +
                                                        '",  "Redirection":"' +
                                                        values.Redirection +
                                                        '", "Content":"' +
                                                        values.Content +
                                                        '", "ButtonText":"' +
                                                        values.ButtonText +
                                                        '", "ClientId":"' +
                                                        values.ClientId +
                                                        '", "CountrySelect":"' +
                                                        values.CountrySelect +
                                                        '", "DateSend":"' +
                                                        values.DateSend +
                                                        '", "DateExpiration":"' +
                                                        values.DateExpiration +
                                                        '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! ');
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            data = JSON.parse(text);
                                                            if (data.HasError) {
                                                                webix.message({
                                                                    text: _('Error, comuniquese con soporte. '),
                                                                    type: 'error',
                                                                });
                                                            } else {
                                                                webix.message(
                                                                    _('Banner invasivo enviado satisfactoriamente'),
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                            $$('formSendInvasiveBanner').setValues(
                                                $$('formSendInvasiveBanner').getCleanValues(),
                                            );
                                            this.getTopParentView().hide();
                                            console.log(values);
                                        } else {
                                            webix.message({
                                                title: '¡Error!',
                                                type: 'alert-error',
                                                text: _('Completa los campos...'),
                                            });
                                        }
                                    },
                                },
                            ],
                        },
                    ],
                    elementsConfig: {
                        on: {
                            /**
                             * Event handler for form field changes to trigger validation.
                             */
                            onChange: function () {
                                this.validate();
                            },
                        },
                    },
                },
            },
        });
        var popupEditInvasiveBanner = webix.ui({
            view: 'window',
            id: 'EditInvasiveBanner',
            width: screen.width < 500 ? 350 : 650,
            height: screen.width < 500 ? 800 : 620,
            fullscreen: screen.width < 500 ? true : false,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Editar banner invasivo'),
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center',
            modal: true,
            body: {
                view: 'scrollview',
                scroll: 'y',
                body: {
                    view: 'form',
                    id: 'formEditInvasiveBanner',
                    width: screen.width < 500 ? 350 : 650,
                    height: screen.width < 500 ? 800 : 570,
                    elements: [
                        {
                            view: 'text',
                            label: _('Id'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Id',
                            labelWidth: 150,
                            readonly: true,
                        },
                        {
                            view: 'text',
                            label: _('URL Imagen'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Image',
                            labelWidth: 150,
                        },
                        {
                            view: 'text',
                            label: _('URL Redirección'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Redirection',
                            labelWidth: 150,
                        },
                        {
                            view: 'textarea',
                            label: _('Contenido'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'Content',
                            labelWidth: 150,
                        },
                        {
                            view: 'text',
                            label: _('Texto del botón'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'ButtonText',
                            labelWidth: 150,
                        },
                        {
                            view: 'textarea',
                            label: _('Usuarios Id'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'ClientId',
                            labelWidth: 150,
                        },
                        {
                            view: 'richselect',
                            name: 'CountrySelectId',
                            label: "<span class='icon-language'></span>" + _('País'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            placeholder: _('Click para seleccionar '),
                            labelWidth: 150,
                            options: {
                                body: {
                                    /**
                                     * Template function for rendering country options with flags.
                                     * @param {Object} obj - The country object.
                                     * @returns {String} HTML string for the country option.
                                     */
                                    template: function (obj) {
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries,
                                },
                            },
                        },
                        {
                            view: 'datepicker',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha envío'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'DateSend',
                            stringResult: true,
                            labelWidth: 150,
                            timepicker: true,
                            format: '%d %M %Y %H:%i:%s',
                        },
                        {
                            view: 'datepicker',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha expiración'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'DateExpiration',
                            stringResult: true,
                            labelWidth: 150,
                            timepicker: true,
                            format: '%d %M %Y %H:%i:%s',
                        },
                        {
                            view: 'combo',
                            label: _('Estado'),
                            labelPosition: screen.width < 500 ? 'top' : 'left',
                            name: 'State',
                            options: [
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelWidth: 150,
                        },
                        {
                            cols: [
                                {
                                    view: 'button',
                                    value: _('Cancelar'),
                                    click: function () {
                                        this.getTopParentView().hide();
                                        $$('formEditInvasiveBanner').setValues(
                                            $$('formEditInvasiveBanner').getCleanValues(),
                                        );
                                    },
                                },
                                {
                                    view: 'button',
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        var values = $$('formEditInvasiveBanner').getValues();
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json',
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/SaveInvasiveBanner',
                                                '{"Id":"' +
                                                    values.Id +
                                                    '", "Image":"' +
                                                    values.Image +
                                                    '",  "Redirection":"' +
                                                    values.Redirection +
                                                    '", "Content":"' +
                                                    values.Content +
                                                    '", "ButtonText":"' +
                                                    values.ButtonText +
                                                    '", "ClientId":"' +
                                                    values.ClientId +
                                                    '", "CountrySelect":"' +
                                                    values.CountrySelectId +
                                                    '", "DateSend":"' +
                                                    values.DateSend +
                                                    '", "DateExpiration":"' +
                                                    values.DateExpiration +
                                                    '", "State":"' +
                                                    values.State +
                                                    '"}',
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message('Error! ');
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        data = JSON.parse(text);
                                                        if (data.HasError) {
                                                            webix.message({
                                                                text: _('Error, comuniquese con soporte. '),
                                                                type: 'error',
                                                            });
                                                        } else {
                                                            webix.message(
                                                                _('Banner invasivo editado satisfactoriamente'),
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('formEditInvasiveBanner').setValues(
                                            $$('formEditInvasiveBanner').getCleanValues(),
                                        );
                                        this.getTopParentView().hide();
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        $$('formEditInvasiveBanner').bind($$('datatable'));
        this.on(this.app, 'messages:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1;
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });
        this.on(this.app, 'sendInvasiveBanner:button', (filterData) => {
            popupSendInvasiveBanner.show();
            $$('formSendInvasiveBanner').clearValidation();
        });
    }
}

// FILE DOCUMENTED
